import React, {useState} from 'react';
import TextInput from '../../../Shared/TextInput/TextInput';
import Footer from '../Assets/footer';
import ErrorIcon from '../Assets/SVG/errorIcon';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import Config from '../../../../Config';
import {isMobile} from 'react-device-detect';
import WhatsappIcon from '../Assets/SVG/whatsappIcon';

const NoPrimaryScreen = (props) => {
  const whatsAppLink = `https://wa.me/${Config.whatsAppSelfCare}?force_isolation=true&text=`;

  const mobileCall = (
    <BtnSubmit
      className='btn-submit-white TipCallBtn'
      isDisplayWhatsAppIcon={false}
      onclick={() => {
        window.location.href = 'tel:*'+ window.Config.technicalSupportPhone;
      }}
      text={`חייגו ${window.Config.technicalSupportPhone} לנציג שירות`}
    />
  );
  const desktopCall = <div className='TipCall'>לשיחה עם נציג {window.Config.technicalSupportPhone}</div>;
  return (
    <div className='screenContainer'>
      <ErrorIcon />
      <h3 className='heading withSecondary'>צריכים אתכם בטלפון</h3>
      <h4 className='secondaryHeading errorSecondary'>
        כדי להשלים את ההתחברות לאזור האישי צריך <br />
        להגדיר את מספר הטלפון שישמש אותנו ליצירת <br />
        קשר, אפשר לעשות את זה בקלות דרך מוקד <br />
        השירות שלנו ב-{window.Config.technicalSupportPhone}
      </h4>

      {isMobile ? mobileCall : desktopCall}
      <BtnSubmit
        className='btn-submit mt-20'
        onclick={() => {
          window.location.href = Config.staticWebSiteUrl;
        }}
        text='לעמוד הבית '
      />
    </div>
  );
};

export default NoPrimaryScreen;
